import { render, staticRenderFns } from "./edit-message-patterns-compact.vue?vue&type=template&id=bd954260&scoped=true&"
import script from "./edit-message-patterns-compact.vue?vue&type=script&lang=js&"
export * from "./edit-message-patterns-compact.vue?vue&type=script&lang=js&"
import style0 from "./edit-message-patterns-compact.vue?vue&type=style&index=0&id=bd954260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd954260",
  null
  
)

export default component.exports